/**
 * Account endpoints.
 *
 *   getProfile    -> GET  UserProfile/Index
 *   updateProfile -> POST UserProfile/Save
 *
 * Which fields appear and which are editable comes from dbo.ProfileAttributes —
 * the same ProfileFieldsSetup that إعدادات الملف الشخصي edits.
 */
import { session } from '../../app/session'

const NETWORK_DELAY = 220

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export async function getProfile() {
  await delay(NETWORK_DELAY)
  const { users, groups } = await import('../../data/directory')
  const { profileFields, storedSettings } = await import('../../data/settings')

  const user = users.find((row) => row.userName === session.login) ?? null

  return {
    profile: user && {
      Username: user.userName,
      EnglishName: user.nameEn ?? '',
      ArabicName: user.name ?? '',
      Gender: String(user.gender ?? ''),
      Email: user.email ?? '',
      Phone: '',
      Mobile: user.mobile ?? '',
      EmployeeId: '',
      DepartmentId: user.groupIds?.[0] ?? '',
      Attribute1: '',
      Attribute2: '',
      Attribute3: '',
      Attribute4: '',
      Attribute5: '',
    },
    fields: profileFields,
    groups,
    settings: storedSettings,
  }
}

export async function updateProfile(values) {
  await delay(NETWORK_DELAY)
  return { ok: true, values }
}
